/**
 * figma-session.js
 *
 * A module-level singleton that tracks the active Figma chunk import
 * session ACROSS all open storyboard tabs / ClipboardManager instances.
 *
 * Why module-level and not React state?
 *   React state is per-component. Two storyboard tabs each mount their own
 *   ClipboardManager. A chunk lock stored in React state in tab A is
 *   invisible to tab B. A plain JS module is a singleton — same object
 *   in both tabs' bundle (within the same browser tab / SPA navigation).
 */
const figmaSession = {
    activeExportKey: null,
    ownerStoryboardId: null,
    dispatchInProgress: false,

    startChunkSession: function(exportKey, storyboardId) {
      this.activeExportKey   = exportKey;
      this.ownerStoryboardId = storyboardId;
    },
    endChunkSession: function() {
      this.activeExportKey   = null;
      this.ownerStoryboardId = null;
    },
    isBlockedByDifferentExport: function(exportKey) {
      return this.activeExportKey !== null && this.activeExportKey !== exportKey;
    },
    isBlockedByDifferentStoryboard: function(storyboardId) {
      return this.activeExportKey !== null && this.ownerStoryboardId !== storyboardId;
    }
  };
  
  export default figmaSession;